import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions';
import 'firebase/analytics';
import { client } from '../index';
import { buildConfig } from '../config';

const config = buildConfig(process.env);

const IS_LOCAL = !!process.env.REACT_APP_LOCAL;
const IS_LOCAL_REMOTE = !!process.env.REACT_APP_LOCAL_REMOTE;
let firebaseConfig = {};
let apiUrl = '';

export const IS_PRODUCTION = !IS_LOCAL && !IS_LOCAL_REMOTE;
// export const IS_PRODUCTION = true;

if (config.feature.staticConfiguration) {
  firebaseConfig = { ...firebaseConfig, ...config.firebase };
  apiUrl = config.apiUrl;
} else if (IS_LOCAL) {
  firebaseConfig = {
    // Point to the RTDB emulator running on localhost.
    // In almost all cases the ns (namespace) is your project ID.
    apiKey: 'AIzaSyDc3ymeHRHVYQwjqbVy20AVXfdayLqWy9Q',
    databaseURL: 'http://localhost:9000?ns=dancefloor-app',
    projectId: 'dancefloor-app',
    authDomain: 'localhost',
  };
  apiUrl = 'http://localhost:5001/dancefloor-app/us-central1/api/graphql';
} else if (IS_LOCAL_REMOTE) {
  firebaseConfig = {
    // Point to the RTDB emulator running on localhost.
    // In almost all cases the ns (namespace) is your project ID.
    apiKey: 'AIzaSyDc3ymeHRHVYQwjqbVy20AVXfdayLqWy9Q',
    databaseURL: 'https://dancefloor-app.firebaseio.com',
    projectId: 'dancefloor-app',
    authDomain: 'localhost',
  };
  apiUrl = 'http://localhost:5001/dancefloor-app/us-central1/api/graphql';
} else {
  firebaseConfig = {
    apiKey: 'AIzaSyDc3ymeHRHVYQwjqbVy20AVXfdayLqWy9Q',
    authDomain: 'dancefloor-app.firebaseapp.com',
    databaseURL: 'https://dancefloor-app.firebaseio.com',
    projectId: 'dancefloor-app',
    storageBucket: 'dancefloor-app.appspot.com',
    messagingSenderId: '627815904887',
    appId: '1:627815904887:web:e2cd82deb0a060a1457872',
    measurementId: 'G-WJ9Y8KG7J8',
  };
  apiUrl = 'https://us-central1-dancefloor-app.cloudfunctions.net/api';
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

if (IS_PRODUCTION) {
  firebase?.analytics();
}

export const db = firebase.database();

if (config.feature.staticConfiguration) {
  if (config.firebase.database.local) {
    db.useEmulator(config.firebase.database.host, config.firebase.database.port);
  }
  if (config.firebase.auth.local) {
    const auth = firebase.auth();
    auth.useEmulator(config.firebase.auth.host);
  }
}

let usingLocalEmulators = false;
export const useFunctionsEmulatorOnLocal = () => {
  if (config.feature.staticConfiguration) {
    // initialized in FunctionsService
    // if (config.firebase.functions.local) {
    //   usingLocalEmulators = true;
    //   firebase.functions().useFunctionsEmulator(config.firebase.functions.host);
    // }
  } else if (!usingLocalEmulators && (IS_LOCAL || IS_LOCAL_REMOTE)) {
    usingLocalEmulators = true;
    firebase.functions().useEmulator('localhost', 5001);
  }
};

export const createFunction = <T = any, R = any>(name: string): ((data: T) => Promise<R>) => {
  const callable = firebase.functions().httpsCallable(name);
  return async (data: T) => (await callable(data)).data;
};

export const onLogOut = async () => {
  await firebase.auth().signOut();
  await client.clearStore();
  localStorage.clear();
};

export const getApiUrl = () => apiUrl;
